"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import loadingButtonClasses from "@mui/lab/LoadingButton/loadingButtonClasses";
import InnerButton from "@mui/material/Button";
import buttonClasses from "@mui/material/Button/buttonClasses";
import { styled } from "@mui/material/styles";
import { useCheckThemeContext } from "../../hooks/useCheckThemeContext";
import { button } from "../../styles/utils/button.module";
export const pixelButtonStyling = (dt, color) => {
    return Object.assign(Object.assign(Object.assign({ height: dt.button.medium, [`&.${buttonClasses.sizeSmall}`]: {
            height: dt.button.small,
        }, [`&.${buttonClasses.sizeMedium}`]: {
            height: dt.button.medium,
        }, [`&.${buttonClasses.sizeLarge}`]: {
            height: dt.button.large,
        } }, (color === "neutral" && {
        [`&.${buttonClasses.contained}[class]`]: button(dt.cta.contained, ["neutral"], dt),
        [`&.${buttonClasses.outlined}[class]`]: button(dt.cta.outlined, ["neutral"], dt),
        [`&.${buttonClasses.text}[class]`]: button(dt.cta.outlined, ["neutral"], dt),
    })), ((color === "inverted" || color === "invertedPrimary") && {
        [`&.${buttonClasses.contained}[class]`]: button(dt.cta.contained, ["inverted"], dt),
        [`&.${buttonClasses.outlined}[class]`]: button(dt.cta.outlined, ["inverted"], dt),
        [`&.${buttonClasses.text}[class]`]: button(dt.cta.outlined, ["inverted"], dt),
    })), (color === "invertedPrimary" && {
        [`&.${buttonClasses.text}[class]`]: {
            color: dt.color.inversePrimary,
            ".PixelIcon": {
                color: dt.color.inversePrimary,
            },
            [`&[disabled], &.disabled, &.${buttonClasses.disabled}`]: {
                color: dt.cta.outlined.color.text.inverted.disabled,
                [`.${loadingButtonClasses.loadingIndicator}`]: {
                    color: dt.cta.outlined.color.text.inverted.disabled,
                },
                ".PixelIcon": {
                    backgroundColor: dt.cta.outlined.color.text.inverted.disabled,
                },
            },
        },
    }));
};
const StyledButton = styled(InnerButton)(({ theme, color }) => {
    const dt = theme.pixel;
    return pixelButtonStyling(dt, color);
});
const Text = styled("div")(() => {
    return {
        justifyContent: "center",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    };
});
export const Button = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    useCheckThemeContext("Button");
    return (_jsx(StyledButton, Object.assign({}, props, { "data-pixel": "Button", ref: ref, children: _jsx(Text, { className: "Pxl-Button-label", children: children }) })));
});
